/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const dealflowReviewerDtoSchema = z.object({
  role: z.optional(z.string()),
  name: z.optional(z.string()),
  initials: z.optional(z.string()),
  vote: z.optional(z.string()),
  comment: z.optional(z.string()),
});
